import cn from 'classnames';
import React, {CSSProperties, FC} from 'react';

import {IDashboardEntry} from 'modules/data/data-types';

import {WidgetWrapper} from '../../components/widget-wrapper';
import {useStatisticsInitialization} from '../../hooks/use-statistics-initialization';

import './bar-statistics.less';

interface IBarStatisticsProps {
    entries: IDashboardEntry;
    title?: string;
    label?: string;
    settings?: {
        gridRowsLimit?: number;
        noWrapDescriptions?: boolean;
        styles?: CSSProperties;
    };
}
export const BarStatistics: FC<IBarStatisticsProps> = ({
    entries, settings = {}, title, label,
}: IBarStatisticsProps) => {
    const {
        entriesTotal, statisticsData, statisticsLength,
    } = useStatisticsInitialization({
        entries,
        settings: {lowercaseEntityKeys: false},
    });

    const {
        gridRowsLimit = 3,
        noWrapDescriptions = true,
        styles = {},
    } = settings;

    return (
        <WidgetWrapper title={title}>
            <div
                style={styles}
                className="bar-statistics"
            >
                <div className="bar-statistics__up-bar">
                    <div className="bar-statistics__up-bar__total">
                        {entries.recordsTotal || entriesTotal}
                    </div>
                    <div className="bar-statistics__up-bar__label">
                        {label ?? 'всего'}
                    </div>
                </div>
                <div className="bar-statistics__bar-wrapper">
                    {statisticsData.length > 0 ? statisticsData.map(data => (
                        <div
                            key={data.key}
                            style={{width: `${data.percent}%`, backgroundColor: data.color}}
                            className="bar-statistics__bar-wrapper__bar"
                        />
                    )) : (<div className="bar-statistics__bar-wrapper__fallback" />)}
                </div>

                <div
                    style={{
                        gridTemplateRows: `repeat(${statisticsLength >= gridRowsLimit
                            ? gridRowsLimit : statisticsLength}, ${noWrapDescriptions ? '28px' : 'auto'})`,
                    }}
                    className="bar-statistics__description"
                >
                    {statisticsData.map(data => (
                        <div
                            key={data.key}
                            className={cn('bar-statistics__description__block', {
                                'bar-statistics__description__block_no-wrap': noWrapDescriptions,
                            })}
                        >
                            <div
                                style={{backgroundColor: data.color}}
                                className="bar-statistics__description__block__border"
                            />
                            <span className={cn('bar-statistics__description__block__key', {
                                'bar-statistics__description__block__key_no-wrap': noWrapDescriptions,
                            })}
                            >
                                {data.key}
                            </span>
                            <span className="bar-statistics__description__block__value">{data.value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </WidgetWrapper>
    );
};
